import { icons } from "lucide-react";
import { Box } from "lucide-react";

interface ObjectTypeIconProps {
  icon: string | null;
  color?: string | null;
  size?: number;
}

export function ObjectTypeIcon({ icon, color, size = 18 }: ObjectTypeIconProps) {
  const name = icon?.replace("lucide:", "") ?? null;
  const LucideIcon = name
    ? (icons as Record<string, React.ComponentType<{ size?: number; style?: React.CSSProperties }>>)[name]
    : null;

  const Component = LucideIcon ?? Box;
  return <Component size={size} style={color ? { color } : undefined} />;
}
